import { combineReducers, configureStore } from "@reduxjs/toolkit";
import navigationReducer from "../navigationSlice";
import accountReducer from "../accountSlice";
import userSlice from "../userSlice";
import schedulerReducer from "../schedulerSlice";
import dmsReducer from "../dmsSlice";
import userRolesReducer from "../userRolesSlice";
import companyReducer from "../companySlice";
import clientReducer from "../clientSlice";
import licenceReducer from "../licenceSlice";
import accountantReducer from "../accountantSlice";
import personReducer from "../personSlice";
import documentReducer from "../documentSlice";
import addressReducer from "../addressSlice";
import applicationReducer from "../applicationSlice";
import taxSettingsReducer from "../applicationSettingsSlice";
import preAccountingReducer from "../preAccountingSlice";
import centreReducer from "../centreSlice";
import auditReducer from "../auditSlice";
import contactReducer from "../contactSlice";
import paymentRequestReducer from "../paymentRequestSlice";
import paymentOrderReducer from "../paymentOrderSlice";
import paymentOfferReducer from "../paymentOfferSlice";
import paymentCouponReducer from "../paymentCouponSlice";
import vatRatesReducer from "../vatRatesSlice";
import paymentTransactionReducer from "../paymentTransactionSlice";
import documentItemsReducer from "../documentItemsSlice";
import documentCentreSharesReducer from "../documentCentreSharesSlice";
import feedbackReducer from "../feedbackSlice";
import accountantOnboardingReducer from "../accountantOnboardingSlice";
import taskReducer from "../taskSlice";
import registrationRequestReducer from "../registrationRequestSlice";
import emailReducer from "../emailSlice";
import contractReducer from "../contractSlice";
import activityReducer from "../activitySlice";
import officerReducer from "../officerSlice";
import approverReducer from "../approverSlice";
import subscriptionLicenceReducer from "../subscriptionLicenceSlice";
import subscriptionInvoiceReducer from "../subscriptionInvoiceSlice";

import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { tableStateUpdatesReduxListenerInstance } from "./reduxTableStateUpdates";
import { applicationSettingsStateUpdateReduxListenerInstance } from "../applicationSettingsSlice.persistor";

const taxGuruReducer = combineReducers({
    navigation: navigationReducer,
    account: accountReducer,
    scheduler: schedulerReducer,
    dms: dmsReducer,
    user: userSlice,
    userRoles: userRolesReducer,
    company: companyReducer,
    client: clientReducer,
    licence: licenceReducer,
    accountant: accountantReducer,
    person: personReducer,
    document: documentReducer,
    address: addressReducer,
    taxApp: applicationReducer,
    taxSettings: taxSettingsReducer,
    preAccounting: preAccountingReducer,
    centre: centreReducer,
    audit: auditReducer,
    contact: contactReducer,
    paymentRequest: paymentRequestReducer,
    paymentTransaction: paymentTransactionReducer,
    paymentOrder: paymentOrderReducer,
    paymentOffer: paymentOfferReducer,
    paymentCoupon: paymentCouponReducer,
    task: taskReducer,
    documentItems: documentItemsReducer,
    documentCentreShares: documentCentreSharesReducer,
    feedback: feedbackReducer,
    accountantOnboarding: accountantOnboardingReducer,
    registrationRequest: registrationRequestReducer,
    vatRates: vatRatesReducer,
    email: emailReducer,
    activity: activityReducer,
    contract: contractReducer,
    officer: officerReducer,
    approver: approverReducer,
    subscriptionLicence: subscriptionLicenceReducer,
    subscriptionInvoice: subscriptionInvoiceReducer,
});

export const store = configureStore({
    reducer: taxGuruReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().prepend(
            tableStateUpdatesReduxListenerInstance.middleware,
            applicationSettingsStateUpdateReduxListenerInstance.middleware
        ),
});

export type TaxReduxState = ReturnType<typeof store.getState>;
export type TaxReduxDispatch = typeof store.dispatch;
export const useTaxDispatch: () => TaxReduxDispatch = useDispatch; // Export a hook that can be reused to resolve types
export const useTaxSelector: TypedUseSelectorHook<TaxReduxState> = useSelector;
